/* eslint-disable max-len */
import { observer } from 'mobx-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useRef } from 'react';
import { COURSE_TYPE, LEVEL_COURSE_STRING } from '../../../core/configs/constants';
import { convertVideoDuration, extractContent } from '../../../core/utils/common';
import classNames from 'classnames';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../../core/utils/hook';

const HomeSlideComponent = observer(({ slides }) => {
    // other
    const navigate = useNavigate();

    // store
    const {
        courseStore: { setSearchCourseInfo }
    } = useStore();

    // ref
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    return (
        <div>
            <Swiper
                direction='horizontal'
                modules={[Navigation]}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current
                }}
                onInit={(swiper) => {
                    setTimeout(() => {
                        if (swiper.params?.navigation) {
                            if (typeof swiper.params.navigation !== 'boolean') {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }
                        }
                    });
                }}
                slidesPerView='auto'
                spaceBetween={25}
                allowTouchMove={true}
                className='carousel-course-training-container'
            >
                {slides.map((slide) => {
                    const onRefCourseListScreen = () => {
                        setSearchCourseInfo(slide);
                        navigate('/course-list');
                    }
                    return (
                        <SwiperSlide key={slide.id}>
                            <div className='slide-content'>
                                <div className='slide-content-thumnail cursor-pointer' onClick={() => onRefCourseListScreen()}>
                                    <img src={slide?.thumbnail || '/images/img-1.png'} alt='' />
                                    {
                                        slide?.type?.length > 1 && (
                                            <div className='slide-content-type'>
                                                {
                                                    slide?.type?.includes(COURSE_TYPE.SOCIETY_ACCREDITED_CREDITS) ? '精神薬学会認定薬剤師'
                                                        : slide?.type?.includes(COURSE_TYPE.HERBAL_MEDICINE) ? '漢方薬・生薬認定薬剤師'
                                                            : slide?.type?.includes(COURSE_TYPE.DRUG_THERAPY_CERTIFIED_PHARMACIST) ? '小児薬物療法認定薬剤師'
                                                                : ''
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                                <div className='slide-content-header line-clamp-1'>{slide.themeName}</div>
                                <div className='slide-content-title line-clamp-2 cursor-pointer' onClick={() => onRefCourseListScreen()}>{slide.name}</div>
                                <div className='slide-content-info'>
                                    <div className='d-flex align-items-center flex-gap-5'>
                                        <img src='/images/icon2.svg' className='mg-0' alt='' />{slide.totalLecture ?? 0} コンテンツ
                                    </div>
                                    <div className='d-flex align-items-center flex-gap-5'>
                                        <img src='/images/icon1.svg' className='mg-0' alt='' /> {convertVideoDuration(slide.totalTime)} 分
                                    </div>
                                    {
                                        slide?.level && (
                                            <div className='d-flex flex-gap-5 align-items-center'>
                                                <img src='/images/icon-level-course.svg' className='level mg-0' alt='' style={{ color: '#afb0b5' }}/>
                                                {LEVEL_COURSE_STRING[slide.level]}
                                            </div>
                                        )
                                    }
                                </div>
                                <div className='slide-content-desc text-justify-inter-word line-clamp-3'>
                                    {slide?.description ? extractContent(slide.description) : ''}
                                </div>
                                    
                                <div className='slide-content-btn'>
                                    <button type='button' onClick={() => onRefCourseListScreen()}>受講を始める</button>
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                })}
                <div className='slide-button-container'>
                    <div ref={prevRef} className={classNames('flex-none cursor-pointer')}>
                        <img src='/images/icon-button-left.svg' style={{ height: '33px', width: '33px' }} />
                    </div>
                    <div ref={nextRef} className={classNames('flex-none cursor-pointer')}>
                        <img src='/images/icon-button-right.svg' style={{ height: '33px', width: '33px' }} />
                    </div>
                </div>
            </Swiper>
        </div>
    )
});

export default HomeSlideComponent;